// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#organizationalChartWrapper {
    margin-left: auto;
    margin-right: auto;
}

#organizationalChartContainer {
    float: left;
    padding: 1em;
    /* width: 100%; */
}

ol.organizationalChart,
ol.organizationalChart ol,
ol.organizationalChart li,
ol.organizationalChart li > div { position: relative; }

ol.organizationalChart,
ol.organizationalChart ol {
    list-style: none;
    margin: 0;
    padding: 0;
}

ol.organizationalChart { text-align: center; }

ol.organizationalChart ol { padding-top: 1em; }

ol.organizationalChart li > div > div.expander {
    margin-left: -6px;
    margin-top: -6px;
    position: absolute;
    width: 100%;
    z-index: 100;
}

ol.organizationalChart div.founded {
    border-bottom: 2px solid #73AA30;
    border-left: 25px solid #73AA30;
    border-right: 2px solid #73AA30;
    border-top: 2px solid #73AA30;
}

ol.organizationalChart li > div > div.expander > button {
    -ms-border-radius: 10px;
    border-radius: 10px;
    color: #73AA30;
    height: 20px;
    padding: 0;
    width: 20px;
}

ol.organizationalChart .usersList > div {
    line-height: 20px;
    margin: 5px;
    padding: 5px;
    text-align: left;
    min-width: 200px;
}

ol.organizationalChart .usersList > div > .k-avatar {
    float: left;
    margin-top: 5px;
}

ol.organizationalChart .usersList > div > span {
    color: #eeeeee;
    font-size: 75%;
}

ol.organizationalChart a { color: #eeeeee; }

ol.organizationalChart ol:before,
ol.organizationalChart ol:after,
ol.organizationalChart li:before,
ol.organizationalChart li:after,
ol.organizationalChart > li > div:before,
ol.organizationalChart > li > div:after {
    background-color: #b7a6aa;
    content: '';
    position: absolute;
}

ol.organizationalChart ol > li { padding: 1em 0 0 1em; }

ol.organizationalChart > li ol:before {
    height: 1em;
    left: 50%;
    top: 0;
    width: 3px;
}

ol.organizationalChart > li ol:after {
    height: 3px;
    left: 3px;
    top: 1em;
    width: 50%;
}

ol.organizationalChart > li ol > li:not(:last-of-type):before {
    height: 3px;
    left: 0;
    top: 2em;
    width: 1em;
}

ol.organizationalChart > li ol > li:not(:last-of-type):after {
    height: 100%;
    left: 0;
    top: 0;
    width: 3px;
}

ol.organizationalChart > li ol > li:last-of-type:before {
    height: 3px;
    left: 0;
    top: 2em;
    width: 1em;
}

ol.organizationalChart > li ol > li:last-of-type:after {
    height: 2em;
    left: 0;
    top: 0;
    width: 3px;
}

ol.organizationalChart li > div {
    background-color: #fff;
    border-radius: 3px;
    min-height: 2em;
    padding: 0.5em;
}


/*** PRIMARY ***/

ol.organizationalChart > li > div { margin-right: 1em; }

ol.organizationalChart > li > div:before {
    bottom: 2em;
    height: 3px;
    right: -1em;
    width: 1em;
}

ol.organizationalChart > li > div:first-of-type:after {
    bottom: 0;
    height: 2em;
    right: -1em;
    width: 3px;
}

ol.organizationalChart > li > div + div { margin-top: 1em; }

ol.organizationalChart > li > div + div:after {
    height: calc(100% + 1em);
    right: -1em;
    top: -1em;
    width: 3px;
}


/*** SECONDARY ***/

ol.organizationalChart > li > ol:before {
    left: inherit;
    right: 0;
}

ol.organizationalChart > li > ol:after {
    left: 0;
    width: 100%;
}


/*** MEDIA QUERIES ***/

@media (min-width: 500px) {
    ol.organizationalChart {
        margin-left: -1em;
        margin-right: -1em;
    }

    /* PRIMARY */
    ol.organizationalChart > li > div {
        display: inline-block;
        float: none;
        margin: 0 1em 1em 1em;
        vertical-align: bottom;
    }

    ol.organizationalChart > li > div:only-of-type { margin-bottom: 0; }

    ol.organizationalChart > li > div:before,
    ol.organizationalChart > li > div:after {
        bottom: -1em !important;
        top: inherit !important;
    }

    ol.organizationalChart > li > div:before {
        height: 1em !important;
        left: 50% !important;
        width: 3px !important;
    }

    ol.organizationalChart > li > div:only-of-type:after { display: none; }

    ol.organizationalChart > li > div:first-of-type:not(:only-of-type):after,
    ol.organizationalChart > li > div:last-of-type:not(:only-of-type):after {
        bottom: -1em;
        height: 3px;
        width: calc(50% + 1em + 3px);
    }

    ol.organizationalChart > li > div:first-of-type:not(:only-of-type):after { left: calc(50% + 3px); }

    ol.organizationalChart > li > div:last-of-type:not(:only-of-type):after { left: calc(-1em - 3px); }

    ol.organizationalChart > li > div + div:not(:last-of-type):after {
        height: 3px;
        left: -2em;
        width: calc(100% + 4em);
    }

    /* SECONDARY */
    ol.organizationalChart > li > ol {
        display: flex;
        flex-wrap: nowrap;
    }

    ol.organizationalChart > li > ol:before,
    ol.organizationalChart > li > ol > li:before {
        height: 1em !important;
        left: 50% !important;
        top: 0 !important;
        width: 3px !important;
    }

    ol.organizationalChart > li > ol:after { display: none; }

    ol.organizationalChart > li > ol > li {
        flex-grow: 1;
        padding-left: 1em;
        padding-right: 1em;
        padding-top: 1em;
    }

    ol.organizationalChart > li > ol > li:only-of-type { padding-top: 0; }

    ol.organizationalChart > li > ol > li:only-of-type:before,
    ol.organizationalChart > li > ol > li:only-of-type:after { display: none; }

    ol.organizationalChart > li > ol > li:first-of-type:not(:only-of-type):after,
    ol.organizationalChart > li > ol > li:last-of-type:not(:only-of-type):after {
        height: 3px;
        top: 0;
        width: 50%;
    }

    ol.organizationalChart > li > ol > li:first-of-type:not(:only-of-type):after { left: 50%; }

    ol.organizationalChart > li > ol > li:last-of-type:not(:only-of-type):after { left: 0; }

    ol.organizationalChart > li > ol > li + li:not(:last-of-type):after {
        height: 3px;
        left: 0;
        top: 0;
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./ClientApp/styles/css/organizationalChart.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;;kCAGkC,kBAAkB,EAAE;;AAEtD;;IAEI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA,yBAAyB,kBAAkB,EAAE;;AAE7C,4BAA4B,gBAAgB,EAAE;;AAE9C;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,UAAU;IACV,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA,2BAA2B,cAAc,EAAE;;AAE3C;;;;;;IAMI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA,iCAAiC,oBAAoB,EAAE;;AAEvD;IACI,WAAW;IACX,SAAS;IACT,MAAM;IACN,UAAU;AACd;;AAEA;IACI,WAAW;IACX,SAAS;IACT,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,WAAW;IACX,OAAO;IACP,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,MAAM;IACN,UAAU;AACd;;AAEA;IACI,WAAW;IACX,OAAO;IACP,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,WAAW;IACX,OAAO;IACP,MAAM;IACN,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;;AAGA,gBAAgB;;AAEhB,oCAAoC,iBAAiB,EAAE;;AAEvD;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,UAAU;AACd;;AAEA;IACI,SAAS;IACT,WAAW;IACX,WAAW;IACX,UAAU;AACd;;AAEA,0CAA0C,eAAe,EAAE;;AAE3D;IACI,wBAAwB;IACxB,WAAW;IACX,SAAS;IACT,UAAU;AACd;;;AAGA,kBAAkB;;AAElB;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,WAAW;AACf;;;AAGA,sBAAsB;;AAEtB;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA,YAAY;IACZ;QACI,qBAAqB;QACrB,WAAW;QACX,qBAAqB;QACrB,sBAAsB;IAC1B;;IAEA,iDAAiD,gBAAgB,EAAE;;IAEnE;;QAEI,uBAAuB;QACvB,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA,uDAAuD,aAAa,EAAE;;IAEtE;;QAEI,YAAY;QACZ,WAAW;QACX,4BAA4B;IAChC;;IAEA,2EAA2E,qBAAqB,EAAE;;IAElG,0EAA0E,sBAAsB,EAAE;;IAElG;QACI,WAAW;QACX,UAAU;QACV,uBAAuB;IAC3B;;IAEA,cAAc;IACd;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;;QAEI,sBAAsB;QACtB,oBAAoB;QACpB,iBAAiB;QACjB,qBAAqB;IACzB;;IAEA,yCAAyC,aAAa,EAAE;;IAExD;QACI,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA,qDAAqD,cAAc,EAAE;;IAErE;+DAC2D,aAAa,EAAE;;IAE1E;;QAEI,WAAW;QACX,MAAM;QACN,UAAU;IACd;;IAEA,+EAA+E,SAAS,EAAE;;IAE1F,8EAA8E,OAAO,EAAE;;IAEvF;QACI,WAAW;QACX,OAAO;QACP,MAAM;QACN,WAAW;IACf;AACJ","sourcesContent":["#organizationalChartWrapper {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n#organizationalChartContainer {\r\n    float: left;\r\n    padding: 1em;\r\n    /* width: 100%; */\r\n}\r\n\r\nol.organizationalChart,\r\nol.organizationalChart ol,\r\nol.organizationalChart li,\r\nol.organizationalChart li > div { position: relative; }\r\n\r\nol.organizationalChart,\r\nol.organizationalChart ol {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\nol.organizationalChart { text-align: center; }\r\n\r\nol.organizationalChart ol { padding-top: 1em; }\r\n\r\nol.organizationalChart li > div > div.expander {\r\n    margin-left: -6px;\r\n    margin-top: -6px;\r\n    position: absolute;\r\n    width: 100%;\r\n    z-index: 100;\r\n}\r\n\r\nol.organizationalChart div.founded {\r\n    border-bottom: 2px solid #73AA30;\r\n    border-left: 25px solid #73AA30;\r\n    border-right: 2px solid #73AA30;\r\n    border-top: 2px solid #73AA30;\r\n}\r\n\r\nol.organizationalChart li > div > div.expander > button {\r\n    -ms-border-radius: 10px;\r\n    border-radius: 10px;\r\n    color: #73AA30;\r\n    height: 20px;\r\n    padding: 0;\r\n    width: 20px;\r\n}\r\n\r\nol.organizationalChart .usersList > div {\r\n    line-height: 20px;\r\n    margin: 5px;\r\n    padding: 5px;\r\n    text-align: left;\r\n    min-width: 200px;\r\n}\r\n\r\nol.organizationalChart .usersList > div > .k-avatar {\r\n    float: left;\r\n    margin-top: 5px;\r\n}\r\n\r\nol.organizationalChart .usersList > div > span {\r\n    color: #eeeeee;\r\n    font-size: 75%;\r\n}\r\n\r\nol.organizationalChart a { color: #eeeeee; }\r\n\r\nol.organizationalChart ol:before,\r\nol.organizationalChart ol:after,\r\nol.organizationalChart li:before,\r\nol.organizationalChart li:after,\r\nol.organizationalChart > li > div:before,\r\nol.organizationalChart > li > div:after {\r\n    background-color: #b7a6aa;\r\n    content: '';\r\n    position: absolute;\r\n}\r\n\r\nol.organizationalChart ol > li { padding: 1em 0 0 1em; }\r\n\r\nol.organizationalChart > li ol:before {\r\n    height: 1em;\r\n    left: 50%;\r\n    top: 0;\r\n    width: 3px;\r\n}\r\n\r\nol.organizationalChart > li ol:after {\r\n    height: 3px;\r\n    left: 3px;\r\n    top: 1em;\r\n    width: 50%;\r\n}\r\n\r\nol.organizationalChart > li ol > li:not(:last-of-type):before {\r\n    height: 3px;\r\n    left: 0;\r\n    top: 2em;\r\n    width: 1em;\r\n}\r\n\r\nol.organizationalChart > li ol > li:not(:last-of-type):after {\r\n    height: 100%;\r\n    left: 0;\r\n    top: 0;\r\n    width: 3px;\r\n}\r\n\r\nol.organizationalChart > li ol > li:last-of-type:before {\r\n    height: 3px;\r\n    left: 0;\r\n    top: 2em;\r\n    width: 1em;\r\n}\r\n\r\nol.organizationalChart > li ol > li:last-of-type:after {\r\n    height: 2em;\r\n    left: 0;\r\n    top: 0;\r\n    width: 3px;\r\n}\r\n\r\nol.organizationalChart li > div {\r\n    background-color: #fff;\r\n    border-radius: 3px;\r\n    min-height: 2em;\r\n    padding: 0.5em;\r\n}\r\n\r\n\r\n/*** PRIMARY ***/\r\n\r\nol.organizationalChart > li > div { margin-right: 1em; }\r\n\r\nol.organizationalChart > li > div:before {\r\n    bottom: 2em;\r\n    height: 3px;\r\n    right: -1em;\r\n    width: 1em;\r\n}\r\n\r\nol.organizationalChart > li > div:first-of-type:after {\r\n    bottom: 0;\r\n    height: 2em;\r\n    right: -1em;\r\n    width: 3px;\r\n}\r\n\r\nol.organizationalChart > li > div + div { margin-top: 1em; }\r\n\r\nol.organizationalChart > li > div + div:after {\r\n    height: calc(100% + 1em);\r\n    right: -1em;\r\n    top: -1em;\r\n    width: 3px;\r\n}\r\n\r\n\r\n/*** SECONDARY ***/\r\n\r\nol.organizationalChart > li > ol:before {\r\n    left: inherit;\r\n    right: 0;\r\n}\r\n\r\nol.organizationalChart > li > ol:after {\r\n    left: 0;\r\n    width: 100%;\r\n}\r\n\r\n\r\n/*** MEDIA QUERIES ***/\r\n\r\n@media (min-width: 500px) {\r\n    ol.organizationalChart {\r\n        margin-left: -1em;\r\n        margin-right: -1em;\r\n    }\r\n\r\n    /* PRIMARY */\r\n    ol.organizationalChart > li > div {\r\n        display: inline-block;\r\n        float: none;\r\n        margin: 0 1em 1em 1em;\r\n        vertical-align: bottom;\r\n    }\r\n\r\n    ol.organizationalChart > li > div:only-of-type { margin-bottom: 0; }\r\n\r\n    ol.organizationalChart > li > div:before,\r\n    ol.organizationalChart > li > div:after {\r\n        bottom: -1em !important;\r\n        top: inherit !important;\r\n    }\r\n\r\n    ol.organizationalChart > li > div:before {\r\n        height: 1em !important;\r\n        left: 50% !important;\r\n        width: 3px !important;\r\n    }\r\n\r\n    ol.organizationalChart > li > div:only-of-type:after { display: none; }\r\n\r\n    ol.organizationalChart > li > div:first-of-type:not(:only-of-type):after,\r\n    ol.organizationalChart > li > div:last-of-type:not(:only-of-type):after {\r\n        bottom: -1em;\r\n        height: 3px;\r\n        width: calc(50% + 1em + 3px);\r\n    }\r\n\r\n    ol.organizationalChart > li > div:first-of-type:not(:only-of-type):after { left: calc(50% + 3px); }\r\n\r\n    ol.organizationalChart > li > div:last-of-type:not(:only-of-type):after { left: calc(-1em - 3px); }\r\n\r\n    ol.organizationalChart > li > div + div:not(:last-of-type):after {\r\n        height: 3px;\r\n        left: -2em;\r\n        width: calc(100% + 4em);\r\n    }\r\n\r\n    /* SECONDARY */\r\n    ol.organizationalChart > li > ol {\r\n        display: flex;\r\n        flex-wrap: nowrap;\r\n    }\r\n\r\n    ol.organizationalChart > li > ol:before,\r\n    ol.organizationalChart > li > ol > li:before {\r\n        height: 1em !important;\r\n        left: 50% !important;\r\n        top: 0 !important;\r\n        width: 3px !important;\r\n    }\r\n\r\n    ol.organizationalChart > li > ol:after { display: none; }\r\n\r\n    ol.organizationalChart > li > ol > li {\r\n        flex-grow: 1;\r\n        padding-left: 1em;\r\n        padding-right: 1em;\r\n        padding-top: 1em;\r\n    }\r\n\r\n    ol.organizationalChart > li > ol > li:only-of-type { padding-top: 0; }\r\n\r\n    ol.organizationalChart > li > ol > li:only-of-type:before,\r\n    ol.organizationalChart > li > ol > li:only-of-type:after { display: none; }\r\n\r\n    ol.organizationalChart > li > ol > li:first-of-type:not(:only-of-type):after,\r\n    ol.organizationalChart > li > ol > li:last-of-type:not(:only-of-type):after {\r\n        height: 3px;\r\n        top: 0;\r\n        width: 50%;\r\n    }\r\n\r\n    ol.organizationalChart > li > ol > li:first-of-type:not(:only-of-type):after { left: 50%; }\r\n\r\n    ol.organizationalChart > li > ol > li:last-of-type:not(:only-of-type):after { left: 0; }\r\n\r\n    ol.organizationalChart > li > ol > li + li:not(:last-of-type):after {\r\n        height: 3px;\r\n        left: 0;\r\n        top: 0;\r\n        width: 100%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
